import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedUserService as AuthenticatedUser } from './auth/auth-guard.service';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { CallbackComponent } from './callback/callback.component';
import { HomeModule } from '../app/home/home.module';

const ROUTES: Routes = [
	{
		path: '',
		loadChildren: () => import('../app/home/home.module').then(m => m.HomeModule),
		canActivate: [AuthenticatedUser],
	},
	{ path: 'callback', component: CallbackComponent },
	{ path: 'forbidden', component: ForbiddenComponent },
	// { path: '**', redirectTo: '' }
];

@NgModule({
	imports: [RouterModule.forRoot(ROUTES, { useHash: false })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
